<template>
    <div class="ma-1">
        <v-btn v-if="bo" x-small class="mt-0  mb-1 ml-2 white--text" color="green darken-4"
                :to="{name:'journal.edit.bo',params:{id:this.$route.params.journal_id,model:'Board'}}" >
                edit
            </v-btn>
        <div class="ql-ed" >
            <span v-html="editorialInfos"></span>
        </div>
    </div>
</template>
<script>

import {mapGetters} from 'vuex';
import router from '../../../router';

export default {
     props:{
        bo: {
            type:Boolean,
            default:false
        },
    },
    data() {
        return{
            editorialInfos:null,
        }
    },
    created() {
        this.getEditorialInfos();
    },
    computed:{
        ...mapGetters('library',{
            journal:'journal',
        })
    },
    methods: {
        async getEditorialInfos(){
            try{
                const res = await axios.get('/index.php/api/library/journals/editorial-board/'+this.$route.params.journal_id );
                if(res){
                    this.editorialInfos = res.data;
                }
            } catch (error) {
                throw error;
            }
        },
    },
}
</script>
